import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  convivente,
  death,
  others,
  parents,
  spouses,
  menorTutela,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';
import { declaracaoVeracidade } from '../../utils/rulesByKey';

const { constants } = parentesco;

export const SaldoMATDocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),

    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),

    anexoCertidaoCasamento: dynamicRule('casamento'),

    anexoCertidaoNascimento: dynamicRule('nascimento'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),

    anexoOutros: dynamicRule(),
    anexoTermoTutelaJudicial: dynamicRule('menorTutela'),
    ...declaracaoVeracidade,
  };

  const docs = {
    commons: [...commons],
    others: [...others],
    [constants.PAI]: [...death, ...parents],
    [constants.MAE]: [...death, ...parents],
    [constants.CONJUGE]: [...death, ...spouses],
    [constants.EX_CONJUGE]: [...death, ...spouses],
    [constants.FILHO]: [...death, ...childs],
    [constants.CONVIVENTE]: [...death, ...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...death, ...childs, ...certidaoGenitor],
    [constants.MENOR_TUTELA]: [...childs, ...menorTutela, ...death],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
